import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ZikataToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'zikatagov-toasts',
  standalone: true,
  imports: [NgbToastModule, NgFor],
  template: `
    <ngb-toast
      *ngFor="let toast of toastService.toasts"
      [class]="toast.classname"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      (hidden)="toastService.remove(toast)"
    >
      {{ toast.text }}
    </ngb-toast>
  `,
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-3',
    style: 'z-index: 1200',
  },
})
export class ZikataToastContainerComponent {
  constructor(public toastService: ZikataToastService) {}
}
